"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addVoucherHandler = addVoucherHandler;
var AddVoucherFailed = _interopRequireWildcard(require("@ori-events/add-voucher-failed"));
var _api = require("../api");
var _logger = require("../logger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const dispatchAddVoucherFailed = detail => {
  const event = new CustomEvent(AddVoucherFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
async function addVoucherHandler({
  detail: {
    voucherCode
  }
}, {
  client,
  sessionId,
  tenant
}) {
  // STEP 1 - Add voucher via API
  try {
    await (0, _api.addVoucher)({
      client,
      globalShoppingVoucherCodeDto: {
        voucherCode
      },
      sessionId,
      tenant
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while adding voucher in addVoucher handler'
    });
    const errorEvent = new CustomEvent(AddVoucherFailed.Name, {
      detail: {
        isSuccess: false,
        localizedMessage: String(error),
        message: String(error)
      }
    });
    window.dispatchEvent(errorEvent);
    return false;
  }

  // STEP 2 - reload shopping context data
  const data = await (0, _api.fetchShoppingContextData)();
  if (AddVoucherFailed.isAddVoucherErrorResponse(data)) {
    dispatchAddVoucherFailed(data);
    return false;
  }
  return data;
}
